import trend from "../../assets/icons/trending.svg";
import "./Trending.scss";

const Trending = ({
  trendingData,
  setSearchTerm,
  onClickHandler,
  subredditSearch,
}) => {
  return (
    <article className="trending">
      <img src={trend} alt="trending icon" className="trending__img" />
      <p className="trending__title">
        Trending<span className="trending__title--hide"> searches</span>:
      </p>
      {trendingData.map((subreddit, i) => (
        <span
          className={`trending__subreddit ${
            i > 2 ? "trending__subreddit--hide" : ""
          }`}
          onClick={() => {
            setSearchTerm(subreddit);
            onClickHandler(subreddit, subredditSearch);
          }}
          key={i}
        >
          {subreddit}
        </span>
      ))}
    </article>
  );
};

export default Trending;
